import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

// Approval confirmation for the Customer Order Requests view. Collects the
// approver's notes before hitting ApproveQuoteOrder. Mirrors ConfirmModal's
// layout; Submit is disabled while the request is in flight.
const ApproveQuoteModal = ({
  show,
  onHide,
  onSubmit,
  notes,
  onNotesChange,
  submitting = false,
  title = "Approve Quote",
}) => {
  return (
    <Modal show={show} size="md" onHide={onHide}>
      <Modal.Header closeButton>
        <div className="modal-title h4">{title}</div>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <Form.Control
            as="textarea"
            rows={3}
            name="approvedNotes"
            value={notes}
            onChange={(e) => onNotesChange(e.target.value)}
            placeholder="Enter approval notes"
            disabled={submitting}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button variant="success" onClick={onSubmit} disabled={submitting}>
          {submitting ? "Submitting..." : "Submit"}
        </Button>
        <Button variant="secondary" onClick={onHide} disabled={submitting}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ApproveQuoteModal;
